module.exports = __webpack_public_path__ + "static/media/zamusic.9bfee968.mp3";